import { render, staticRenderFns } from "./confirmDialog.vue?vue&type=template&id=63a09f15&scoped=true"
import script from "./confirmDialog.vue?vue&type=script&lang=js"
export * from "./confirmDialog.vue?vue&type=script&lang=js"
import style0 from "./confirmDialog.vue?vue&type=style&index=0&id=63a09f15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a09f15",
  null
  
)

export default component.exports